import { Space } from 'antd'

import { AuctionListTimeRenderProps } from './interface'

export const AuctionListTimeRender = ({
  record: { startTime, endTime }
}: AuctionListTimeRenderProps) => {
  return (
    <Space orientation='vertical'>
      {startTime}
      {endTime}
    </Space>
  )
}
